import React, { useState, Component, useMemo, useEffect } from "react";
import { Switch } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import DataTable from "../../_Components/DataTable";

import _ from "lodash";
import SwalMessage from "../../_Components/SwalMessage";
import { Button } from "react-bootstrap";

import ApiPublicPromoCodeService from "../../../../core/api/api.publicPromoCode";

function DataGridPublicPromoCode({
  data,
  setShowModalPromoCode,
  setShowModalQrPromoCode,
  setSelectedPromoCodeId,
  setSelectedQrCode,
}) {
  const handleChangeIsDefault = (name) => (event) => {
    callApiService(name, 1);
  };
  async function callApiService(item, flag) {
    const response = await ApiPublicPromoCodeService.removePublicPromoCode({
      id: item.allPublicPromoCodeViewModel.id,
      Status: !item.allPublicPromoCodeViewModel.isDeleted,
    });
    if (response.succeeded == true)
      document.getElementById("submitButton").click();

    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }

  const columns = useMemo(() => [
    {
      accessor: "allPublicPromoCodeViewModel.id",
      Header: "شماره",
      minWidth: 50,
    },
    {
      accessor: "allPublicPromoCodeViewModel.code",
      Header: "کد تخفیف",
      minWidth: "100px",
    },
    {
      accessor: "allPublicPromoCodeViewModel.expireDate",
      Header: "تاریخ انقضا",
      minWidth: "100px",
      Cell: ({ row }) => (
        <>{row.original.allPublicPromoCodeViewModel.expireDate}</>
      ),
    },
    {
      accessor: "allPublicPromoCodeViewModel.promoCodePublicationName",
      Header: "نام کد تخفیف",
      minWidth: "100px",
    },
    {
      accessor: "countUsedPublicPromoCategory",
      Header: "تعداددفعات استفاده",
      minWidth: "100px",
    },
    {
      Header: "وضعیت کد تخفیف",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={
              row.original.allPublicPromoCodeViewModel.isDeleted == true
                ? false
                : true
            }
            //checked={state.checkedA}
            value="row.original.allPublicPromoCodeViewModel.isDeleted"
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            onChange={handleChangeIsDefault(row.original)}
          />
        </div>
      ),
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 200,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          {/* مشاهده  */}

          <Link
            title="گزارش فروش"
            key={row.original.id}
            to={{ pathname: "/usedPromoCodeByUser", search: `?promoCode=${row.original.allPublicPromoCodeViewModel.code}` }}
            target="_blank"
            state={{ promoCodeId: row.original.allPublicPromoCodeViewModel.id }}
            className="btn btn-light-warning btn-sm mr-2 btn-icon"
          >
            <i className="far fa-file-alt text-small"></i>
          </Link>
          {/* ویرایش */}
          {/* <Link className="btn btn-light-primary btn-sm mr-2 btn-icon" to={`/promoCategoryAgent/${row.original.id}`}>
                            <i className='far fa-edit text-small'></i>
                        </Link> */}

          {/* <Link className="btn btn-light-primary btn-sm mr-2 btn-icon"
                     key={0}
                     to={{
                         pathname: `/PublicPromoCode/${row.original.allPublicPromoCodeViewModel.id}`,
                         state: { neWPublicPromoCode: true ,
                                 promoCodeId :row.original.allPublicPromoCodeViewModel.id,
                                 
                         }
                     }}
                 >
                    <i className='far fa-edit text-small'></i>
              </Link> */}
          <Button
            title="ویرایش"
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedPromoCodeId(
                row.original.allPublicPromoCodeViewModel.id
              );
              setShowModalPromoCode(true);
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
          {/* <Link
            title="چاپ"
            to="/printPromoCode"
            className="btn btn-light-info btn-sm mr-2 btn-icon"
          >
            <i className="fas fa-print text-small"></i>
          </Link> */}

          {/* حذف */}
          {/* <div className="btn btn-light-primary btn-sm mr-2 btn-icon">
                            <i className='far fa-trash-alt text-small'    onClick={() => { {checkBoxList.some((item)=>item.id==row.original.id) ?  
                                                    handleRemoveItem(checkBoxList,1):  handleRemoveItem(row.original,0)}}}>                                                        
                                                    </i>
                            </div> */}
          {/* <Link className="btn btn-light-primary btn-sm mr-2 btn-icon"
                            key={0}
                            to={{
                                pathname: `/PublicPromoCode/${row.original.allPublicPromoCodeViewModel.code}`,
                                state: {
                                    neWQrCodePromoCode: true,
                                    qrPromoCode: row.original.allPublicPromoCodeViewModel.code,

                                }
                            }}
                        >
                            <i className='fa fa-qrcode text-small '></i>
                        </Link> */}
          <Button
            title="اطلاعات کد تخفیف"
            className="btn btn-light-success btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedQrCode(row.original.allPublicPromoCodeViewModel.code);
              setShowModalQrPromoCode(true);
            }}
          >
            <i className="fa fa-qrcode text-small "></i>
          </Button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGridPublicPromoCode;
